var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notifications-unsubscribe ctsform" }, [
    _c(
      "div",
      { staticClass: "sports-page" },
      [
        _c(
          "v-layout",
          { staticClass: "page-layout" },
          [
            _c(
              "v-flex",
              {
                ref: "maincolumn",
                staticClass: "main-column",
                style: { paddingTop: _vm.headerHeight + "px" }
              },
              [
                _c("resize-observer", { on: { notify: _vm.mainColumnResize } }),
                _vm._v(" "),
                _c("div", { staticClass: "accpage" }, [
                  _vm.isProcessing
                    ? _c(
                        "div",
                        { staticClass: "notifications-unsubscribe__spinner" },
                        [
                          _c("v-progress-circular", {
                            staticClass: "redirecting-circular-progress",
                            attrs: { indeterminate: "" }
                          })
                        ],
                        1
                      )
                    : _c("div", [
                        _vm.unsubscribeSuccessfull
                          ? _c(
                              "div",
                              { staticClass: "notifications__message" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { color: "success" }
                                  },
                                  [_vm._v("check_circle")]
                                ),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("NotificationsUnsubscribe.OK")
                                    ) +
                                    "\n            "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.unsubscribeSuccessfull
                          ? _c(
                              "div",
                              { staticClass: "notifications__message" },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { color: "success" }
                                  },
                                  [_vm._v("check_circle")]
                                ),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("NotificationsUnsubscribe.ok")
                                    ) +
                                    "\n            "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "buttons" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "outlined",
                                attrs: { color: "gray" },
                                on: { click: _vm.goToHomepage }
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "icon material-icons",
                                    attrs: { "aria-hidden": "true" }
                                  },
                                  [_vm._v("navigate_before")]
                                ),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t(
                                        "Account.ChangePassword.GoToHomepage"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-010131d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-010131d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/NotificationsUnsubscribeComponent.vue
// module id = null
// module chunks = 